/*@ngInject*/
const UIMaxCharsDirective = function () {

    let linkFunction = function ($scope, $elem) {
        function handleKeypress(event) {
            let limit;

            // Ignore backspace
            if (event.keyCode !== 8) {
                limit = parseInt($scope.uiMaxChars);

                if ($elem[0].value.length >= limit) {
                    event.preventDefault();
                }
            }
        }

        function handlePaste(event) {
            let limit = parseInt($scope.uiMaxChars),
                newValue,
                isLimited = true;

            if (window.clipboardData) {
                newValue = window.clipboardData.getData('Text');
            } else if (event.originalEvent.clipboardData) {
                newValue = event.originalEvent.clipboardData.getData('text/plain');
            }

            if (!_.isNaN(limit)) {
                isLimited = $elem[0].value.length + newValue.length <= limit;
            } else {
                isLimited = true;
            }



            if (!isLimited) {
                event.preventDefault();
            }
        }

        $elem.on('keypress', handleKeypress);
        $elem.on('keydown', handleKeypress);
        $elem.on('paste', handlePaste);

        $scope.$on('$destroy', function () {
            $elem.off('keypress.uiMaxChars');
            $elem.off('keydown.uiMaxChars');
            $elem.off('paste.uiMaxChars');
        });
    };

    return {
        restrict: 'A',
        scope: {
            uiMaxChars: '@'
        },
        link: linkFunction
    };
};

angular.module('umCore')
    .directive('uiMaxChars', UIMaxCharsDirective);
